//Libs
import * as _ from 'lodash';
//Constants
import * as ACTIONS from './actionTypes';
import { DEFAULT_PAGE_SIZE } from './constants'
import { MEDIA_ACTION } from 'features/Dealers/Listings/Images/state/constants'
//Types
import { LMimages, LMMediadata } from './types';
import { ActionGetLMImagesAPISuccess, ActionGetLMImagesAPI, ActionPostLMImagesAPISuccess, ActionPostLMImagesAPI } from './actions';
//utils
import { parseValidationDataFromResponse } from './utils';

export interface EngineImagesState {
    dealerImages?: LMimages

}

const defaultState: EngineImagesState = {};

type GetLMImagesAction = ActionGetLMImagesAPISuccess | ActionPostLMImagesAPISuccess;

function dealerimagesReducer(state: EngineImagesState = defaultState, action: GetLMImagesAction): EngineImagesState {
    switch (action.type) {
        case ACTIONS.GET_LMIMAGES_API_SUCCESS:
            {
                const originalDealerLMInfo = (action as ActionGetLMImagesAPISuccess).lmimages
                return {
                    ...state,
                    dealerImages: { ...originalDealerLMInfo },
                }

            }
        case ACTIONS.POST_LMIMAGES_API_SUCCESS:
            {
                const mediaResponse = (action as ActionPostLMImagesAPISuccess).lmMediaResponse
                if(mediaResponse && mediaResponse.validation && !mediaResponse.validation.allImagesValidOrFixed && state && state.dealerImages && state.dealerImages.mediadata)
                {
                    for(let i=0;i<state.dealerImages.mediadata.length;i++)
                    {
                        if(state.dealerImages.mediadata[i].category=="COVER" && state.dealerImages.mediadata[i].action==MEDIA_ACTION.REMOVE)
                        {
                            state.dealerImages.mediadata[i].action=MEDIA_ACTION.UNCHANGE;
                        }
                    }
                }
                return {
                    ...state,
                    dealerImages: state.dealerImages ? {
                        ...state.dealerImages,
                        mediadata: mediaResponse.validation.allImagesValidOrFixed ? mediaResponse.media : state.dealerImages.mediadata,
                        validationdata: parseValidationDataFromResponse(mediaResponse),
                    } : undefined
                }
            }
        default: {
            return {
                ...state
            }
        }
    }

}


export default dealerimagesReducer